// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3erSx","title":"Images45_title__2-bhy","images":"Images45_images__2scWs"};